import "@mui/lab/themeAugmentation";
import { createTheme } from "@mui/material/styles";

export const RiotTheme = createTheme({
    typography: {
        fontFamily:
            '"Jost", sans-serif',
    },
    palette: {
        primary: {
            main: '#224366',
            light: '#A4D0FF',
            dark: '#649CD7',
        },
        secondary: {
            main: '#00ff00',
        },
    },
});
